import React from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type ForceGraph from './ui/index.tsx';
import type { ForceGraphProps } from './ui/types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyForceGraph = lazyForPaint<typeof ForceGraph>(
	() => import(/* webpackChunkName: "async-jira-servicedesk-insight-graphs-force-graph" */ './ui'),
	{ ssr: false },
);

export const AsyncLazyForceGraph = (props: ForceGraphProps) => (
	<ErrorBoundary
		id="async.jira-servicedesk-insight-graphs-force-graph"
		packageName="atlassian/jira-servicedesk-insight-graphs-force-graph"
	>
		<Placeholder name="iira-servicedesk-insight-graphs-force-graph" fallback={null}>
			<LazyForceGraph {...props} />
		</Placeholder>
	</ErrorBoundary>
);
